export default {
	field_cannot_be_empty: "O campo não pode estar vazio",
	content_cannot_exceed_10_emojis: "O contéudo do template não pode conter mais de 10 emojis.",
	content_cannot_exceed_1024_characters: "O conteúdo do template não pode exceder de 1024 caracteres",
	invalid_url: "Digite uma URL válida",
	buttons_exceeded_max_limit: "O template pode ter no máximo 10 botões",
	url_buttons_exceeded_max_limit: "São permitidos no máximo 2 botões de URL",
	phone_buttons_exceeded_max_limit: "É permitido apenas 1 botão de número de telefone",
	copy_code_buttons_exceeded_max_limit: "É permitido apenas 1 botão de copiar código",
	quick_reply_buttons_must_be_grouped: "Botões de resposta rápida devem estar agrupados e não podem ser intercalados com outros tipos de botão",
	header_contains_invalid_characters: "O cabeçalho não pode conter quebras de linha, emojis ou caracteres de formatação (*, _, ~, `)."
}
